export default __webpack_public_path__ + "static/media/clock.4850c436.svg";